import { useTranslation } from "react-i18next";
import useModuleSelect from "../../useModuleSelect";
import { SubMenuItem } from "src/constants/modules";
import Section from "./components/Section/Section";
import { SECTIONS, SectionTitle, ModuleEntry } from "./constants";

export default function LandingContent() {
  const { t } = useTranslation();
  const { items } = useModuleSelect();

  const sections = (Object.entries(SECTIONS) as [SectionTitle, ModuleEntry[]][]).map(([title, modules]) => ({
    title,
    items: modules.map(({ type }) => items.find((item) => item.type === type)).filter((item): item is SubMenuItem => Boolean(item)),
  }));

  return (
    <div className="flex w-full w-full flex-col overflow-hidden">
      <div className="md:px-15 bg-background-default relative z-10 -mt-6 flex items-center justify-start rounded-t-xl md:mt-0 md:rounded-none">
        <div className="divide-border-default flex w-full flex-col gap-4 divide-y rounded-xl p-6">
          {sections.map((section, index) => (
            <Section
              key={section.title}
              title={t(`Landing.sections.${section.title}.title`)}
              items={section.items}
              index={index}
              subtitle={t(`Landing.sections.${section.title}.subtitle`)}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
